import React from "react"
import QuestionGroup from "./QuestionGroup"
import QuestionList from "./QuestionList"
import { FormPane } from "./Panes"
import defaultRouter from "./defaultRouter"
import navigationVisibility from "./navigationVisibility"
import styled from "styled-components"
import Navigation from "./Navigation"
import { media } from "../components/mediaStylesNew"
import { SlideHeightProvider } from "./Panes/SlideHeightContext"
import { SlideHeightDummyElement } from "./Panes/SlideHeightDummyElement"

const Layout = styled.div`
  padding-top: 100px;
  max-width: 800px;
  margin: auto;
  position: relative;
  /*   padding-left: 140px;
  ${media.tablet`
    padding-left: 0;
  `} */
`

export default class Form extends React.Component {
  questionContainer = []

  render() {
/*     const questionNav = this.props.questions.map(question => {
      let name = ""
      if (question.title) {
        name = question.title
      } else if (question.questions.length === 1) {
        name = question.questions[0].question?.text
      }
      return name
    }) */
    return (
      <>
        {/*         <SideBar>
          {questionNav.map((question, index) => (
            <QuestionName>
              <CircledNumber>{index + 1}</CircledNumber>
              {question}
            </QuestionName>
          ))}
        </SideBar> */}
        <Layout>
          <SlideHeightProvider>
            {this.props.visible && (
              <FormPane
                initialState={this.props.initialState}
                plugins={[
                  defaultRouter(this.props.questions, this.props.routing),
                  navigationVisibility(this.props.questions),
                ]}
                navigation={
                  <Navigation
                    onBack={() => {
                      this.questionContainer = this.questionContainer.filter(
                        container => container !== null
                      )
                      this.questionContainer.forEach(container => {
                        container.back()
                      })
                    }}
                    onNext={() => {
                      this.questionContainer = this.questionContainer.filter(
                        container => container !== null
                      )
                      this.questionContainer.forEach(container => {
                        container.next()
                      })
                    }}
                    fixed={this.props.isNavigationFixed}
                    showProgress={this.props.showProgress}
                  />
                }
                onQuestionProcessed={this.props.onQuestionProcessed}
                onQuestionView={this.props.onQuestionView}
              >
                {this.props.questions.map((questionGroup, index) => {
                  if (questionGroup.__typename === "SanityQuestionGroup") {
                    return (
                      <QuestionGroup
                        wrappedComponentRef={questionGroup =>
                          this.questionContainer.push(questionGroup)
                        }
                        key={questionGroup.identifier}
                        {...questionGroup}
                      />
                    )
                  }
                  return (
                    <QuestionList
                      key={`${questionGroup.identifier}-${index}`}
                      wrappedComponentRef={questionList =>
                        this.questionContainer.push(questionList)
                      }
                      {...questionGroup}
                    />
                  )
                })}
              </FormPane>
            )}
            <SlideHeightDummyElement />
          </SlideHeightProvider>
        </Layout>
      </>
    )
  }
}

Form.defaultProps = {
  visible: true,
  onQuestionProcessed: () => {},
  onQuestionView: () => {},
  initialState: {},
}
